import { render, staticRenderFns } from "./ComplianceReport.vue?vue&type=template&id=aa63fc3a&scoped=true"
import script from "./ComplianceReport.vue?vue&type=script&lang=js"
export * from "./ComplianceReport.vue?vue&type=script&lang=js"
import style0 from "./ComplianceReport.vue?vue&type=style&index=0&id=aa63fc3a&prod&scoped=true&lang=css"
import style1 from "./ComplianceReport.vue?vue&type=style&index=1&id=aa63fc3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa63fc3a",
  null
  
)

export default component.exports